import React, { useEffect, useState } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import resumesecpdf from '../../resume-sec.pdf';
import { HashLink as Link } from 'react-router-hash-link';
import './TopNav.css';

function TopNav(props) {
    const [currentHash, setCurrentHash] = useState(window.location.hash || '#about');

    useEffect(() => {
        const handler = () => setCurrentHash(window.location.hash || '#about');
        window.addEventListener('hashchange', handler);
        return () => window.removeEventListener('hashchange', handler);
    }, []);
    return (
        <Navbar 
            id="header-nav" 
            collapseOnSelect 
            expand="lg" 
            bg="dark" 
            variant="dark"
            sticky="top"
            role="navigation"
            aria-label="Main navigation"
        >
            <Navbar.Brand 
                href="#top" 
                className="navbar-brand-link"
                aria-label="Alexander Yeara - Back to top"
            >
                Alexander Yeara
            </Navbar.Brand>
            
            <Navbar.Toggle 
                aria-controls="responsive-navbar-nav"
                aria-label="Toggle navigation menu"
            />
            
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="ms-auto navbar-right-section" aria-label="Page sections and external links">
                    {/* Page Navigation Links */}
                    <Link 
                        className="nav-link page-link" 
                        smooth 
                        to="#about"
                        role="button"
                        aria-current={currentHash === '#about' ? 'page' : undefined}
                    >
                        About
                    </Link>
                    <Link 
                        className="nav-link page-link" 
                        smooth 
                        to="#experience"
                        role="button"
                        aria-current={currentHash === '#experience' ? 'page' : undefined}
                    > 
                        Experience
                    </Link>
                    <Link 
                        className="nav-link page-link" 
                        smooth 
                        to="#portfolio"
                        role="button"
                        aria-current={currentHash === '#portfolio' ? 'page' : undefined}
                    >
                        Projects
                    </Link>
                    <Link 
                        className="nav-link page-link" 
                        smooth 
                        to="#certifications"
                        role="button"
                        aria-current={currentHash === '#certifications' ? 'page' : undefined}
                    >
                        Certifications
                    </Link>
                    <Link 
                        className="nav-link page-link" 
                        smooth 
                        to="#disclosures"
                        role="button"
                        aria-current={currentHash === '#disclosures' ? 'page' : undefined}
                    >
                        Blog & Disclosures
                    </Link>
                    <Link 
                        className="nav-link page-link" 
                        smooth 
                        to="#contact"
                        role="button"
                        aria-current={currentHash === '#contact' ? 'page' : undefined}
                    >
                        Contact
                    </Link>

                    {/* Divider */}
                    <div className="nav-divider"></div>

                    {/* External Links */}
                    <Nav.Item>
                        <Nav.Link
                            href="https://linkedin.com/in/alexanderyeara"
                            className="nav-link external-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Connect on LinkedIn (opens in new window)"
                        >
                            LinkedIn
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link
                            href="https://github.com/axyeara"
                            className="nav-link external-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Visit GitHub profile (opens in new window)"
                        >
                            GitHub
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link
                            href={resumesecpdf}
                            className="nav-link external-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Download CV (PDF, opens in new window)"
                        >
                            CV (Outdated)
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
}

export default TopNav;
